import { GET } from "lib/core/api"
import { PupilSocialEmotionalNote } from "entities/pupils/pages/profile/social-emotional/social-emotional.reducer"
import { createAction, createAsyncThunk } from "@reduxjs/toolkit"
import { serializeError } from "lib/core/redux-tools.utils"

export const getPupilSocialEmotionalNotes = createAsyncThunk<
  PupilSocialEmotionalNote[],
  number
>(
  "pupilSocialEmotionalNotes/getPupilSocialEmotionalNotes",
  async (pupilId: number) => {
    const result = await GET("/pupil_note", {
      query: {
        pupil_id: pupilId,
        category__name__in: "social_emotional",
      },
    })

    return result as PupilSocialEmotionalNote[]
  },
  {
    serializeError,
  },
)

export const addPupilSocialEmotionalNote = createAction(
  "pupilSocialEmotionalNotes/addPupilSocialEmotionalNote",
  (note) => ({ payload: note }),
)

export const updatePupilSocialEmotionalNote = createAction(
  "pupilSocialEmotionalNotes/updatePupilSocialEmotionalNote",
  (note) => ({ payload: note }),
)

export const deletePupilSocialEmotionalNote = createAction(
  "pupilSocialEmotionalNotes/deletePupilSocialEmotionalNote",
  (noteId) => ({ payload: noteId }),
)
